import { cn } from "@/lib/utils";

export function PencilIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("size-3 text-rose-red", className)}
      viewBox="0 0 12 12"
      {...props}
    >
      <path
        d="M8.094 1.755a.257.257 0 00-.354 0L2.034 7.462a.25.25 0 000 .353l2.14 2.14a.25.25 0 00.353 0l5.706-5.705a.25.25 0 000-.354l-2.14-2.14zM1.5 8.355a.25.25 0 00-.414.1l-1.07 3.21a.25.25 0 00.316.317l3.21-1.07a.25.25 0 00.1-.415L1.5 8.356zM11.484.508a1.806 1.806 0 00-2.494 0l-.356.357a.25.25 0 000 .353l2.14 2.14a.25.25 0 00.353 0L11.484 3a1.765 1.765 0 000-2.492z"
        fill="currentColor"
      />
    </svg>
  );
}
